(function () {
  var form = document.querySelector('[data-ll-custom-form]');
  if (!form) return;

  var messageEl = form.querySelector('[data-ll-custom-body]');
  var textarea = form.querySelector('[data-ll-custom-message]');
  var charCount = form.querySelector('[data-ll-custom-char]');
  var uploadZone = form.querySelector('[data-ll-custom-upload]');
  var uploadInput = form.querySelector('[data-ll-custom-file]');
  var uploadName = form.querySelector('[data-ll-custom-file-name]');
  var consent = form.querySelector('[data-ll-custom-consent]');
  var maxChars = 1000;

  function val(name) {
    var el = form.querySelector('[data-field="' + name + '"]');
    return el && el.value ? el.value.trim() : '';
  }

  function initPhoneCodePickers() {
    var pickers = form.querySelectorAll('[data-ll-phone-code]');
    if (!pickers.length) return;

    function closeAll(except) {
      pickers.forEach(function (picker) {
        if (picker === except) return;
        var toggle = picker.querySelector('[data-ll-phone-code-toggle]');
        var list = picker.querySelector('[data-ll-phone-code-list]');
        if (toggle) toggle.setAttribute('aria-expanded', 'false');
        if (list) list.hidden = true;
      });
    }

    pickers.forEach(function (picker) {
      var toggle = picker.querySelector('[data-ll-phone-code-toggle]');
      var list = picker.querySelector('[data-ll-phone-code-list]');
      var hiddenInput = picker.querySelector('[data-ll-phone-code-input]');
      var emojiEl = picker.querySelector('[data-ll-phone-emoji]');
      var dialEl = picker.querySelector('[data-ll-phone-dial]');
      if (!toggle || !list || !hiddenInput) return;

      toggle.addEventListener('click', function () {
        var isOpen = toggle.getAttribute('aria-expanded') === 'true';
        closeAll(picker);
        toggle.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
        list.hidden = isOpen;
      });

      list.querySelectorAll('button[data-code]').forEach(function (option) {
        option.addEventListener('click', function () {
          var code = option.getAttribute('data-code');
          var name = option.getAttribute('data-name');
          var optionEmoji = option.querySelector('.ll-custom__phone-emoji');

          hiddenInput.value = code;
          if (dialEl) dialEl.textContent = code;
          if (emojiEl && optionEmoji) emojiEl.textContent = optionEmoji.textContent;

          list.querySelectorAll('button').forEach(function (btn) {
            btn.classList.remove('is-selected');
          });
          option.classList.add('is-selected');

          toggle.setAttribute('aria-expanded', 'false');
          toggle.setAttribute('aria-label', 'Country code: ' + (name || code));
          list.hidden = true;
        });
      });

      var defaultOption = list.querySelector('button[data-iso="us"]');
      if (defaultOption) defaultOption.classList.add('is-selected');
    });

    document.addEventListener('click', function (event) {
      if (!event.target.closest('[data-ll-phone-code]')) closeAll();
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeAll();
    });
  }

  initPhoneCodePickers();

  function updateCharCount() {
    if (!textarea || !charCount) return;
    if (textarea.value.length > maxChars) textarea.value = textarea.value.slice(0, maxChars);
    charCount.textContent = textarea.value.length + ' / ' + maxChars + ' characters';
  }

  if (textarea) {
    textarea.addEventListener('input', updateCharCount);
    updateCharCount();
  }

  if (uploadZone && uploadInput) {
    uploadZone.addEventListener('click', function () {
      uploadInput.click();
    });

    uploadZone.addEventListener('dragover', function (event) {
      event.preventDefault();
      uploadZone.classList.add('is-dragover');
    });

    uploadZone.addEventListener('dragleave', function () {
      uploadZone.classList.remove('is-dragover');
    });

    uploadZone.addEventListener('drop', function (event) {
      event.preventDefault();
      uploadZone.classList.remove('is-dragover');
      if (event.dataTransfer && event.dataTransfer.files.length) {
        uploadInput.files = event.dataTransfer.files;
        showFileName();
      }
    });

    uploadInput.addEventListener('change', showFileName);
  }

  function showFileName() {
    if (!uploadName || !uploadInput || !uploadInput.files.length) return;
    uploadName.textContent = 'Selected: ' + uploadInput.files[0].name;
  }

  form.addEventListener('submit', function (event) {
    if (!consent || !consent.checked) {
      event.preventDefault();
      alert('Please agree to the Privacy Policy before submitting.');
      return;
    }

    if (!messageEl) return;

    var lines = [
      'Custom Order Request',
      '-------------------',
      '',
      'CONTACT DETAILS',
      'Full Name: ' + val('full_name'),
      'Email: ' + val('email'),
      'Phone: ' + val('phone_code') + ' ' + val('phone'),
      'Preferred Contact Method: ' + val('contact_method'),
      '',
      'ORDER DETAILS',
      'What would you like us to create?: ' + val('create_type'),
      'Preferred Quantity: ' + (val('quantity') || 'N/A'),
      'Need By Date: ' + (val('need_by') || 'N/A'),
      '',
      'Order Description:',
      val('description'),
      '',
      'Additional Notes:',
      val('notes') || 'N/A'
    ];

    if (uploadInput && uploadInput.files.length) {
      lines.push('', 'Image note: Customer selected "' + uploadInput.files[0].name + '" — please follow up for file.');
    }

    messageEl.value = lines.join('\n');
  });
})();
